import { graphql, Link, StaticQuery } from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import Img from "gatsby-image"
import HeaderSmall from "./headerSmall"

export const stdStarImage = graphql`
  fragment stdStarImage on File {
    childImageSharp {
      fixed(width: 150, height: 95) {
        ...GatsbyImageSharpFixed
      }
    }
  }
`

const GuideStarComponent = ({Section,Provider,Product,Stars,Year}) => (
  <StaticQuery
    query={graphql`
      query {
        bil20195: file(relativePath: { eq: "2020/bil5.png" }) {
          ...tblStarImage
        },
        bil20194: file(relativePath: { eq: "2020/bil4.png" }) {
          ...tblStarImage
        },
        bil20193: file(relativePath: { eq: "2020/bil3.png" }) {
          ...tblStarImage
        }
        bil20192: file(relativePath: { eq: "2020/bil2.png" }) {
          ...tblStarImage
        },
        bil20191: file(relativePath: { eq: "2020/bil1.png" }) {
          ...tblStarImage
        },
        bat20195: file(relativePath: { eq: "2020/bat5.png" }) {
          ...tblStarImage
        },
        bat20194: file(relativePath: { eq: "2020/bat4.png" }) {
          ...tblStarImage
        },
        bat20193: file(relativePath: { eq: "2020/bat3.png" }) {
          ...tblStarImage
        },
        bat20192: file(relativePath: { eq: "2020/bat2.png" }) {
          ...tblStarImage
        },
        bat20191: file(relativePath: { eq: "2020/bat1.png" }) {
          ...tblStarImage
        },
        barn20195: file(relativePath: { eq: "2020/barn5.png" }) {
          ...tblStarImage
        },
        barn20194: file(relativePath: { eq: "2020/barn4.png" }) {
          ...tblStarImage
        },
        barn20193: file(relativePath: { eq: "2020/barn3.png" }) {
          ...tblStarImage
        },
        barn20192: file(relativePath: { eq: "2020/barn2.png" }) {
          ...tblStarImage
        },
        barn20191: file(relativePath: { eq: "2020/barn1.png" }) {
          ...tblStarImage
        },
        hus20195: file(relativePath: { eq: "2020/hus5.png" }) {
          ...tblStarImage
        },
        hus20194: file(relativePath: { eq: "2020/hus4.png" }) {
          ...tblStarImage
        },
        hus20193: file(relativePath: { eq: "2020/hus3.png" }) {
          ...tblStarImage
        },
        hus20192: file(relativePath: { eq: "2020/hus2.png" }) {
          ...tblStarImage
        },
        hus20191: file(relativePath: { eq: "2020/hus1.png" }) {
          ...tblStarImage
        },                
        reise20195: file(relativePath: { eq: "2020/reise5.png" }) {
          ...tblStarImage
        },
        reise20194: file(relativePath: { eq: "2020/reise4.png" }) {
          ...tblStarImage
        },
        reise20193: file(relativePath: { eq: "2020/reise3.png" }) {
          ...tblStarImage
        },
        reise20192: file(relativePath: { eq: "2020/reise2.png" }) {
          ...tblStarImage
        },
        reise20191: file(relativePath: { eq: "2020/reise1.png" }) {
          ...tblStarImage
        },                    
        innbo20195: file(relativePath: { eq: "2020/innbo5.png" }) {
          ...tblStarImage
        },
        innbo20194: file(relativePath: { eq: "2020/innbo4.png" }) {
          ...tblStarImage
        },
        innbo20193: file(relativePath: { eq: "2020/innbo3.png" }) {
          ...tblStarImage
        },
        innbo20192: file(relativePath: { eq: "2020/innbo2.png" }) {
          ...tblStarImage
        },
        innbo20191: file(relativePath: { eq: "2020/innbo1.png" }) {
          ...tblStarImage
        }
      }
    `}
    render={data => (
      <>
        {console.log(data)}
        <div className="moto-widget moto-widget-row__column moto-cell col-sm-4 moto-spacing-top-auto moto-spacing-right-auto moto-spacing-bottom-auto moto-spacing-left-auto" style={{}} data-widget="row.column" data-container="container" data-spacing="aaaa" data-bg-position="left top">
          <div className="moto-widget moto-widget-text moto-preset-default moto-spacing-top-small moto-spacing-right-auto moto-spacing-bottom-medium moto-spacing-left-auto" data-widget="text" data-preset="default" data-spacing="sama" data-visible-on="mobile-v" data-animation>
            <div className="moto-widget-text-content moto-widget-text-editable">
              <div className="moto-text_normal" style={{textAlign: 'center'}}>
                <span className="moto-content-image-plugin-wrapper moto-spacing-top-zero moto-spacing-right-zero moto-spacing-bottom-zero moto-spacing-left-zero">
                  <span className="moto-content-image-container">
                    <Img className="moto-content-image" alt={Provider + " " + Product + " -  " + Stars.toString() + " Defaqto stjerner"} fixed={
                      (Stars === "5" && (Section === "fritidsbåt" || Section === "turbåt" || Section === "bat/turbat"  || Section === "bat/fritidsbat") && data.bat20195.childImageSharp.fixed) ||
                      (Stars === "4" && (Section === "fritidsbåt" || Section === "turbåt" || Section === "bat/turbat"  || Section === "bat/fritidsbat") && data.bat20194.childImageSharp.fixed) ||
                      (Stars === "3" && (Section === "fritidsbåt" || Section === "turbåt" || Section === "bat/turbat"  || Section === "bat/fritidsbat") && data.bat20193.childImageSharp.fixed) ||
                      (Stars === "2" && (Section === "fritidsbåt" || Section === "turbåt" || Section === "bat/turbat"  || Section === "bat/fritidsbat") && data.bat20192.childImageSharp.fixed) ||
                      (Stars === "1" && (Section === "fritidsbåt" || Section === "turbåt" || Section === "bat/turbat"  || Section === "bat/fritidsbat") && data.bat20191.childImageSharp.fixed) ||
                      (Stars === "5" && Section === "barn" && data.barn20195.childImageSharp.fixed) ||
                      (Stars === "4" && Section === "barn" && data.barn20194.childImageSharp.fixed) ||
                      (Stars === "3" && Section === "barn" && data.barn20193.childImageSharp.fixed) ||
                      (Stars === "2" && Section === "barn" && data.barn20192.childImageSharp.fixed) ||
                      (Stars === "1" && Section === "barn" && data.barn20191.childImageSharp.fixed) ||
                      (Stars === "5" && Section === "bil" && data.bil20195.childImageSharp.fixed) ||
                      (Stars === "4" && Section === "bil" && data.bil20194.childImageSharp.fixed) ||
                      (Stars === "3" && Section === "bil" && data.bil20193.childImageSharp.fixed) ||
                      (Stars === "2" && Section === "bil" && data.bil20192.childImageSharp.fixed) ||
                      (Stars === "1" && Section === "bil" && data.bil20191.childImageSharp.fixed) ||
                      (Stars === "5" && Section === "hus" && data.hus20195.childImageSharp.fixed) ||
                      (Stars === "4" && Section === "hus" && data.hus20194.childImageSharp.fixed) ||
                      (Stars === "3" && Section === "hus" && data.hus20193.childImageSharp.fixed) ||
                      (Stars === "2" && Section === "hus" && data.hus20192.childImageSharp.fixed) ||
                      (Stars === "1" && Section === "hus" && data.hus20191.childImageSharp.fixed) ||
                      (Stars === "5" && Section === "reise" && data.reise20195.childImageSharp.fixed) ||
                      (Stars === "4" && Section === "reise" && data.reise20194.childImageSharp.fixed) ||
                      (Stars === "3" && Section === "reise" && data.reise20193.childImageSharp.fixed) ||
                      (Stars === "5" && Section === "innbo" && data.innbo20195.childImageSharp.fixed) ||
                      (Stars === "4" && Section === "innbo" && data.innbo20194.childImageSharp.fixed) ||
                      (Stars === "3" && Section === "innbo" && data.innbo20193.childImageSharp.fixed) ||
                      (Stars === "2" && Section === "innbo" && data.innbo20192.childImageSharp.fixed) ||
                      (Stars === "1" && Section === "innbo" && data.innbo20191.childImageSharp.fixed)
                    }/>
                  </span>
                </span>
              </div>
              <div className="moto-text_normal" style={{textAlign: 'center'}}>
                <div style={{textAlign: 'center'}} className="moto-color2_1">
                  <Link style={{color:'gray',fontSize:'120%'}} to={"/"+Section+"/"+slugifier(Provider)+"/"+slugifier(Product)}><strong>{Provider}: {Product}</strong></Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    )}
    />
)

export default GuideStarComponent

GuideStarComponent.propTypes = {
  Section: PropTypes.string,
  Provider: PropTypes.string,
  Product: PropTypes.string,
  Stars: PropTypes.number,
  Year: PropTypes.string
}

GuideStarComponent.defaultProps = {
  Provider: ``,
  Product: ``,
  Stars: ``,
  Section: ``,
  Year: ``,
}

function slugifier(input) {

  let slugString = input;

  return slugString
  //.toLowerCase()
    .replace(/æ/g,'ae')
    .replace(/ø/g,'o')
    .replace(/å/g,'aa')
    .replace(/&/g,'og')
    .replace(/[^a-zA-Z0-9\/]+/g, '-')
    .replace(/\/-/g,'/')
    .slice(0, 96)                                             // Setting max length to 96
    .replace(/-$/g,'')
}